<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-05-20 14:30:34
 * @LastEditTime: 2020-11-25 11:31:23
-->
<template>
<!-- 内容组件 -->
    <!--<div class="con" :style="{ width:widths+'%' , marginLeft: marginLefts + '%' }">-->
    <div :class="[$route.path=='/dashboard'||$route.path=='/resource/configurationlist'?'dashboard':'con']">
        <!-- 判断是否为设备列表，如果是缓存起来 -->
        <!-- 在路由配置添加keepAlive为true,该页面会被缓存 -->
    <keep-alive :include="include">
    <!-- 所有路由出口 -->
    <router-view></router-view>
    </keep-alive>
    </div>
</template>

<script>
  import {PublicComponent} from '../../../mixins/common'
  export default {
    mixins: [PublicComponent]
  }
</script>


<style scoped>
  .con {
    width: 96%;
    display: block;
    margin: 0 auto;
    padding: 1% 2%;
    background-color: #ffffff;
  }
  .dashboard{
    width: 100%;
    height: 100%;
    display: block;
  }
</style>
